import PictureViewer from "@/components/core/PictureViewer";
import { useTranslation } from "react-i18next";

interface PhotosPropsI {
    photos: string[];
}

export const Photos = ({ photos }: PhotosPropsI) => {
    const { t } = useTranslation();
    return (
        <div
            style={{ marginTop: '30px', marginBottom: '10px' }}
        >
            <p style={{ fontWeight: "bold", color: 'var(--color-text)', marginBottom: "10px" }}>{t("photos")}</p>
            <PictureViewer images={photos} />
        </div>
    );
};
